module.exports = __webpack_public_path__ + "static/media/openid.7c22803f.svg";